import { render, staticRenderFns } from "./DatosCleComponent.vue?vue&type=template&id=15bbf864"
import script from "./DatosCleComponent.vue?vue&type=script&lang=js"
export * from "./DatosCleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports